var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EEEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6157 11.0697L17.6898 7.14379C17.5982 7.05212 17.4731 7 17.3428 7H10.4723C9.66045 7 9 7.66045 9 8.47225V22.2787C9 23.0905 9.66045 23.751 10.4723 23.751H20.2873C21.0991 23.751 21.7595 23.0905 21.7595 22.2787V11.4168C21.7595 11.2829 21.7034 11.1573 21.6157 11.0697ZM17.8335 8.67552L20.084 10.926H18.3243C18.0537 10.926 17.8335 10.7059 17.8335 10.4353V8.67552ZM20.2873 22.7695H10.4723C10.2017 22.7695 9.9815 22.5493 9.9815 22.2787V8.47225C9.9815 8.20165 10.2017 7.9815 10.4723 7.9815H16.852V10.4353C16.852 11.2471 17.5125 11.9075 18.3243 11.9075H20.778V22.2787C20.778 22.5493 20.5579 22.7695 20.2873 22.7695Z",
    fill: "#252931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3241 13.9355H12.4351C12.1641 13.9355 11.9443 14.1553 11.9443 14.4263C11.9443 14.6973 12.1641 14.917 12.4351 14.917H18.3241C18.5951 14.917 18.8149 14.6973 18.8149 14.4263C18.8149 14.1553 18.5951 13.9355 18.3241 13.9355Z",
    fill: "#252931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3243 15.8984H12.4353C12.1643 15.8984 11.9446 16.1182 11.9446 16.3892C11.9446 16.6602 12.1643 16.8799 12.4353 16.8799H18.3243C18.5954 16.8799 18.8151 16.6602 18.8151 16.3892C18.8151 16.1182 18.5954 15.8984 18.3243 15.8984Z",
    fill: "#252931"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3243 17.8623H12.4353C12.1643 17.8623 11.9446 18.082 11.9446 18.3531C11.9446 18.6241 12.1643 18.8438 12.4353 18.8438H18.3243C18.5954 18.8438 18.8151 18.6241 18.8151 18.3531C18.8151 18.082 18.5954 17.8623 18.3243 17.8623Z",
    fill: "#252931"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3611 19.8252H12.4351C12.1641 19.8252 11.9443 20.0449 11.9443 20.3159C11.9443 20.587 12.1641 20.8067 12.4351 20.8067H16.3611C16.6321 20.8067 16.8518 20.587 16.8518 20.3159C16.8518 20.0449 16.6321 19.8252 16.3611 19.8252Z",
    fill: "#252931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.533477dbd3a70e72cfdb6736310ac0fa.svg";
export { ForwardRef as ReactComponent };